export const getProductDetailUrl = ({
  queryParams,
  productSlug,
  variantSlug,
  categorySlug,
}) => {
  let url = `/product/${productSlug}`;

  if (categorySlug && variantSlug) {
    url = `${url}?variant=${variantSlug}&category=${categorySlug}`;
  } else if (variantSlug) {
    url = `${url}?variant=${variantSlug}`;
  } else if (categorySlug) {
    url = `${url}?category=${categorySlug}`;
  }
  return url;
};

export const getProductCompareUrl = ({
  productIds,
  categorySlug,
  comparingProductId,
}) => {
  let url = `/product/compare?${productIds}`;

  if (categorySlug) {
    url = `${url}&category=${categorySlug}`;
  }

  if (comparingProductId) {
    url = `${url}&id=${comparingProductId}`;
  }

  return url;
};

export const getProductListingUrl = ({ categorySlug, queryParams }) => {
  const url = `/category/${categorySlug}?${queryParams.toString()}`;

  return url;
};

export const getProductBrandUrl = ({
  slug = '',
  paramsString = '',
  page = 1,
  limit = 12,
}) => {
  if (paramsString) {
    return `/brand/${slug}?${paramsString.toString()}&brand=${slug}&page=${page}&limit=${limit}`;
  }

  return `/brand/${slug}?brand=${slug}&page=${page}&limit=${limit}`;
};

export const getProductCategoryUrl = ({
  slug,
  paramsString,
  page = 1,
  limit = 12,
  childrenSlug = '',
}) => {
  if (childrenSlug) {
    return `/category/${slug}?category=${childrenSlug}&page=${page}&limit=${limit}`;
  }

  if (paramsString) {
    return `/category/${slug}?${paramsString.toString()}&category=${slug}&page=${page}&limit=${limit}`;
  }

  return `/category/${slug}?category=${slug}&page=${page}&limit=${limit}`;
};

export const getCampaignProductListingPageUrl = ({
  campaignSlug,
  paramsString,
  page = 1,
  limit = 12,
}) => {
  if (paramsString) {
    return `/campaign/${campaignSlug}?${paramsString.toString()}&page=${page}&limit=${limit}`;
  }

  return `/campaign/${campaignSlug}?page=${page}&limit=${limit}`;
};

export const getSearchResultPageUrl = (searchQuery) =>
  `/search-result?query=${searchQuery}&page=1&limit=12`;

export const getSuggestedItemsPageUrl = () =>
  `/suggested-items?page=1&limit=12`;
